import { useEffect, useId, useRef } from 'react'
import './ConfirmationModal.scss'

// A yes/no question. A real dialog for assistive technology: focus starts on
// the safe choice (Cancel) and Escape cancels.
const ConfirmationModal = ({ isOpen, label = 'Confirm', message, onConfirm, onCancel, variant = 'danger', title = 'Are you sure?' }) => {
  const titleId = useId()
  const cancelRef = useRef(null)

  useEffect(() => {
    if (!isOpen) return undefined
    cancelRef.current?.focus()
    const onKey = e => {
      if (e.key === 'Escape') onCancel?.()
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [isOpen, onCancel])

  if (!isOpen) return null

  return (
    <div className="confirmation-modal__overlay" onClick={onCancel}>
      <div className="confirmation-modal" role="dialog" aria-modal="true" aria-labelledby={titleId} onClick={e => e.stopPropagation()}>
        <div className="confirmation-modal__header">
          <div className="confirmation-modal__icon" aria-hidden="true">
            <i className={`ph ${variant === 'danger' ? 'ph-warning' : 'ph-question'}`} />
          </div>
        </div>
        <div className="confirmation-modal__body">
          <h3 id={titleId} className="confirmation-modal__title">
            {title}
          </h3>
          <p className="confirmation-modal__message">{message}</p>
        </div>
        <div className="confirmation-modal__footer">
          <button ref={cancelRef} type="button" className="confirmation-modal__btn confirmation-modal__btn--cancel" onClick={onCancel}>
            Cancel
          </button>
          <button type="button" className={`confirmation-modal__btn confirmation-modal__btn--${variant}`} onClick={onConfirm}>
            {label}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmationModal
